export enum RedirectApp {
  ADMIN = 'admin',
  COMPANY = 'company',
  CANDIDATE = 'candidate',
}
